export default "__VITE_ASSET__CNVHlBVx__"